/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  dummy: 'dummy_558d3d90',
};

export = styles;

loadStyles([{"rawString":".dummy_558d3d90{background:#00f}"}]);
/* tslint:enable */